import React from 'react'
import { connect } from 'react-redux';

const BuyButton = ({ color }) => {
  const { primary, url } = color;
  const styleObj = {
    'backgroundColor': primary
  }
  return (
    <button className="buy-btn" style={styleObj}>
      <a href={url}>Buy Carpe<br />Diem Calendar<br />Freestyle</a>
    </button>
  )
};

const mapStateToProps = state => {
  return {
    color: state.color
  }
}

export default connect(mapStateToProps)(BuyButton);
